import { ClientOnly } from "remix-utils/client-only";

import { UserDTO } from "../types/user";

import { Link } from "./Button/Link";
import { ShareProfileButton } from "./ShareProfileButton";

interface Props {
  user: UserDTO;
  className?: string;
}

export function UserPageFooter({ user, className }: Props) {
  return (
    <div className={className}>
      <div className="w-full">
        <div className="flex justify-between pb-4">
          <Link
            className="border-red-800 text-red-800"
            to="/logout"
            variant="outline"
          >
            log out
          </Link>
          <ClientOnly fallback={<div></div>}>
            {() => <ShareProfileButton username={user.username} />}
          </ClientOnly>
        </div>
      </div>
      {/* messes up the scroll position. come back to it later */}
      {/*<div className="h-0 top-4 relative text-center">*/}
      {/*  <DeleteAccountButton userId={user.id} />*/}
      {/*</div>*/}
    </div>
  );
}
